import React from "react";

import colors from "../../styles/export.module.scss";
import styles from "./index.module.scss";

interface PungoCardTopBottom {
  image: string;
  title: string;
  description: string;
  color: string;
  position?: string;
  order?: string;
}

const PungoCardTopBottom: React.FC<PungoCardTopBottom> = (props) => {
  const { image, title, description, color = colors.green4, position, order } = props;

  const bordercolor = `3px solid ${color}`;

  return (
    <div className={styles.container}>
      {position === "top" &&  
        (<img src={image} alt="Workflow card" className={styles.imageTop} style={{border: bordercolor}} />
      )}

      <div className={styles.header} style={{ color: color }}>
        {title}
      </div>
      {description && <div className={styles.description}>{description}</div>}
      <div className={styles.orderNumber}>{order}</div>


      {position !== "top" &&  
        (<img src={image} alt="Workflow card" className={styles.imageBottom} style={{border: bordercolor}}/>
      )}
    </div>
  );
};

export default PungoCardTopBottom;
